import React from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '../../biLogger/BiLogger.context';
import UserAvatar from '../../User/Avatar';
import Stats from '../_partials/Stats';
import DateAndMatureIndicator from '../_partials/DateAndMatureIndicator';
import Author from '../_partials/Author';
import Title from '../_partials/Title';
import s from './DesktopSubmissionDetails.scss';
var DesktopSubmissionDetails = function (_a) {
    var className = _a.className, deviation = _a.deviation, _b = _a.deviation, author = _b.author, title = _b.title, publishedTime = _b.publishedTime, isMature = _b.isMature, isOwner = _a.isOwner, showTitle = _a.showTitle;
    var noTitle = !title || !showTitle;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(BiLoggerContextProvider, { value: { sectionname: 'author' } },
            author && (React.createElement(UserAvatar, { withTooltip: true, user: author, className: s['avatar'] })),
            noTitle && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['no-title'] },
                    React.createElement(Author, { author: author, isOwner: isOwner, className: s['left'] }),
                    React.createElement("div", { className: s['right'] },
                        React.createElement(Stats, { deviation: deviation }),
                        React.createElement(DateAndMatureIndicator, { publishedTime: publishedTime, isMature: isMature }))))),
            !noTitle && (React.createElement("div", { className: s['right'] },
                React.createElement("div", { className: s['title-row'] },
                    React.createElement(Title, { title: title, showTitle: showTitle, className: s['title'] }),
                    React.createElement(Stats, { deviation: deviation })),
                React.createElement("div", { className: s['author-row'] },
                    React.createElement(Author, { author: author, isOwner: isOwner }),
                    React.createElement(DateAndMatureIndicator, { publishedTime: publishedTime, isMature: isMature })))))));
};
DesktopSubmissionDetails.displayName = 'DesktopSubmissionDetails';
export default DesktopSubmissionDetails;
//# sourceMappingURL=DesktopSubmissionDetails.js.map